export const colors = {
    mainBackground: 'rgb(230,235,238)',
    lightGreyBackground: 'rgb(235,235,235)',
    lightBackground: 'rgb(255,255,255)',
    textLight: 'rgb(255,255,255)',
    textDark: 'rgb(26,26,26)',
    textGrey: 'rgb(126,126,126)',
    primaryColor: 'rgb(14,51,72)',
    primaryColorHover: 'rgb(178,194,200)',
    baseGreyColor: 'rgb(236,235,235)',
    baseLightGreenColor: 'rgb(0,127,144)',
    transparentColor: 'rgba(255,255,255,0)',
};
